import { styled } from '@abyss/web/tools/styled';
import { Flex } from '@abyss/web/ui/Flex';

export const LocationSearchBoxWrapper = styled(Flex, {
  width: '65%',
  marginRight: 'auto',
  marginLeft: 'auto',
  '@screen < $md': {
    width: '100%',
  },
  '#location-input-container': {
    flexWrap: 'nowrap',
  },
});

export const SelectedLocationWrapper = styled(Flex, {
  gap: '5px',
  fontWeight: 400,
  button: {
    paddingLeft: '5px',
    fontWeight: 400,
  },
  flexWrap: 'nowrap',
  '*': {
    fontSize: '1.2rem !important',
  },
});
